import { render, staticRenderFns } from "./NewsPromotions.vue?vue&type=template&id=025665db&scoped=true&"
import script from "./NewsPromotions.vue?vue&type=script&lang=js&"
export * from "./NewsPromotions.vue?vue&type=script&lang=js&"
import style0 from "./NewsPromotions.vue?vue&type=style&index=0&id=025665db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025665db",
  null
  
)

export default component.exports